export enum RouterPaths {
  USERS = '/users',
  LOGIN = '/login',
  CREATE_WIZARD = '/create-wizard',
  FORMS = '/forms',
  FORM_LOGIC = '/form-logic/:formId',
  STEPS = '/steps',
  RESULTS = '/results',
  CREATE_RESULT = '/create-result/:formId',
  SINGLE_RESULT = '/results/:formResultId',
  OPTIONS = '/options',
  STATISTICS = '/statistics',
  POPUPS = '/popups',
  FEEDBACKS = '/feedbacks',
  TRANSLATIONS = '/translations',
  REGISTRATIONS = '/registrations',
  AGENCY_USERS = '/agency-users',
  SEND_ANNOUNCEMENT = '/send-announcement',
  FEATURE_LIMITS = '/feature-limits',
  BILLING_SETTINGS = '/billing-settings',
  PLATFORM_SETTINGS_EDIT = '/platform-settings-edit',
  TEMPLATES = '/templates',
  SINGLE_TEMPLATE = '/templates/:templateId',
  BANS = '/bans',
  BLOG_AUTOMATION = '/blog-automation',
  CRM = '/crm',
  FORM_OPTION_ICON_GENERATOR = '/form-option-icon-generator',
  MCP_TOKENS = '/mcp-tokens',
  EMAIL_CAMPAIGN = '/email-campaign',
  ALL = '*',
}
